/* Ficha de ropa: detrás de cada foto, la misma foto desenfocada llena el escenario (sin huecos crema a los lados) */
(function () {
  [].slice.call(document.querySelectorAll('.pdp2:not(.mgb):not([data-packshot]) .gal > .z')).forEach(function (z) {
    var im = z.querySelector('img'); if (!im || z.querySelector('.amb')) return;
    var a = document.createElement('img');
    a.className = 'amb'; a.alt = ''; a.setAttribute('aria-hidden', 'true'); a.decoding = 'async';
    a.src = im.currentSrc || im.src; a.loading = im.loading || 'lazy';
    z.insertBefore(a, im);
  });
})();

/* nombre del producto en una sola línea: la letra se ajusta al ancho del panel */
(function () {
  var h = document.querySelector('.pdp2 .card2 h1'); if (!h) return;
  function fit() {
    h.style.fontSize = '';
    var max = parseFloat(getComputedStyle(h).fontSize), w = h.parentNode.clientWidth - parseFloat(getComputedStyle(h.parentNode).paddingLeft) - parseFloat(getComputedStyle(h.parentNode).paddingRight);
    if (h.scrollWidth > w) h.style.fontSize = Math.max(16, Math.floor(max * w / h.scrollWidth * 10) / 10) + 'px';
  }
  fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 100); });
})();

/* difuminado elegante en el escenario de la foto (ropa) */
(function () {
  var pdp = document.querySelector('.pdp2:not(.mgb):not([data-packshot])'); if (pdp) pdp.classList.add('st-soft');
})();
